import { useState } from "react";
import { Accordion, Icon } from "semantic-ui-react";
import { CriticalBranchDisplay } from "../../../components/StudyPageTabs/Configurations/Tabs/CCValidationRegion/CCValidationViews/CriticalBranchDisplay";
import { ICalculation } from "../../../models/calculation";

interface IProps {
    calculation: ICalculation;
}

export const CalcPropsManualNECs = ({ calculation }: IProps) => {
    const [open, setOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(-1);

    const handleActiveIndex = (index: number) =>
        activeIndex === index ? setActiveIndex(-1) : setActiveIndex(index);

    return (
        <Accordion id="accordion-CalcPropsManualNECs-a">
            <Accordion.Title id="accordionTitle-CalcPropsManualNECs-a" active={open} index={0} onClick={() => setOpen(!open)}>
                <Icon id="icon-CalcPropsManualNECs-a" name="dropdown" />
                Manual NECs
            </Accordion.Title>
            <Accordion.Content id="accordionContent-CalcPropsManualNECs-a" active={open}>
                <Accordion id="accordion-CalcPropsManualNECs-b">
                    {calculation.criticalBranches.map(cb => (
                        <div id={`div-CalcPropsManualNECs-a-${cb.id}`} key={cb.id} className="manual-nec-list-item">
                            <Accordion.Title
                                id={`accordionTitle-CalcPropsManualNECs-b-${cb.id}`}
                                active={activeIndex === calculation.criticalBranches.indexOf(cb)}
                                index={calculation.criticalBranches.indexOf(cb)}
                                onClick={() =>
                                    handleActiveIndex(calculation.criticalBranches.indexOf(cb))
                                }
                            >
                                <Icon id={`accordion-CalcPropsManualNECs-b-${cb.id}`} name="dropdown" />
                                {cb.id}
                            </Accordion.Title>
                            <Accordion.Content
                                id={`accordionContent-CalcPropsManualNECs-b-${cb.id}`}
                                active={activeIndex === calculation.criticalBranches.indexOf(cb)}
                            >
                                <CriticalBranchDisplay criticalBranch={cb} />
                            </Accordion.Content>
                        </div>
                    ))}
                </Accordion>
            </Accordion.Content>
        </Accordion>
    );
};
